import { Component } from '@angular/core';

@Component({
  selector: 'app-info-fundamental',
  templateUrl: './info-fundamental.component.html',
  styleUrls: ['./info-fundamental.component.scss']
})
export class InfoFundamentalComponent {

}
